
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import { Row, Column } from '~/components/grid'
import { UiTitle, UiButton, UiInput, UiSelect } from '~/components/atoms'

export default {
  components: {
    Row,
    Column,
    UiTitle,
    UiButton,
    UiInput,
    UiSelect,
  },
  data() {
    return {
      isLoading: false,
      hasError: false,
      purposeOptions: [
        {
          id: 'marketing-incentives',
          label: this.$t('business.form.purpose.marketing_incentives'),
          value: 'marketing-incentives',
        },
        {
          id: 'employee-rewards',
          label: this.$t('business.form.purpose.employee_rewards'),
          value: 'employee-rewards',
        },
        {
          id: 'reselling',
          label: this.$t('business.form.purpose.reselling'),
          value: 'reselling',
        },
        {
          id: 'other',
          label: this.$t('business.form.purpose.other'),
          value: 'other',
        },
      ],
      inputFocused: {
        userName: false,
        companyName: false,
        email: false,
        country: false,
        brands: false,
        quantity: false,
        additionalComments: false,
      },
      userName: '',
      companyName: '',
      email: '',
      country: '',
      brands: '',
      purpose: '',
      quantity: '',
      additionalComments: '',
    }
  },
  computed: {
    userNameMessage(): string {
      if (this.inputFocused.userName || !this.$v.userName.$dirty) return ''

      if (!this.$v.userName.required) {
        return this.$t('business.form.input.user_name.error.required')
      }

      return ''
    },
    emailMessage() {
      if (this.inputFocused.email || !this.$v.email.$dirty) return ''

      if (!this.$v.email.email) {
        return this.$t('business.form.input.user_email.error.email')
      }

      if (!this.$v.email.required) {
        return this.$t('business.form.input.user_email.error.required')
      }

      return ''
    },
    companyNameMessage(): string {
      if (this.inputFocused.companyName || !this.$v.companyName.$dirty)
        return ''

      if (!this.$v.companyName.required) {
        return this.$t('business.form.input.company_name.error.required')
      }

      return ''
    },
    countryMessage(): string {
      if (this.inputFocused.country || !this.$v.country.$dirty) return ''

      if (!this.$v.country.required) {
        return this.$t('business.form.input.country.error.required')
      }

      return ''
    },
    brandsMessage(): string {
      if (this.inputFocused.brands || !this.$v.brands.$dirty) return ''

      if (!this.$v.brands.required) {
        return this.$t('business.form.input.brands.error.required')
      }

      return ''
    },
    quantityMessage(): string {
      if (this.inputFocused.quantity || !this.$v.quantity.$dirty) return ''

      if (!this.$v.quantity.required) {
        return this.$t('business.form.input.quantity.error.required')
      }

      return ''
    },
    additionalCommentsMessage(): string {
      if (
        this.inputFocused.additionalComments ||
        !this.$v.additionalComments.$dirty
      )
        return ''

      if (!this.$v.additionalComments.required) {
        return this.$t('business.form.input.additional_comments.error.required')
      }

      return ''
    },
  },
  methods: {
    onInputFocus(inputName) {
      this.inputFocused[inputName] = true
    },
    onInputBlur(inputName) {
      this.inputFocused[inputName] = false
    },
    handleItemSelect({ value }) {
      this.purpose = value
    },
    async submitRequest(e) {
      e.preventDefault()
      this.$v.$touch()

      if (this.$v.$invalid) return
      if (!this.$v.$anyDirty) return
      this.isLoading = true

      axios
        .post('https://hook.eu1.make.com/0ng0l3pn7ev1rh8259p4dky15rxy9h4p', {
          userName: this.userName,
          companyName: this.companyName,
          email: this.email,
          country: this.country,
          brands: this.brands,
          purpose: this.purpose,
          quantity: this.quantity,
          additionalComments: this.additionalComments,
        })
        .then(() => {
          this.$v.$reset()
          this.isLoading = false
          this.$emit('form-submitted')
        })
        .catch(error => {
          this.isLoading = false
          this.hasError = true
          this.$sentry.captureException(error)
        })
    },
  },
  validations: {
    userName: {
      required,
    },
    email: {
      required,
      email,
    },
    companyName: {
      required,
    },
    country: {
      required,
    },
    brands: {
      required,
    },
    quantity: {
      required,
    },
    additionalComments: {
      required,
    },
  },
}
